export const LISTAR_AGENDAMENTOS = 'LISTAR_AGENDAMENTOS'
export const SELECIONAR_AGENDAMENTO = 'SELECIONAR_AGENDAMENTO'
export const LISTAR_ROTAS = 'LISTAR_ROTAS'
export const GET_ALL_OPERADORES = 'GET_ALL_OPERADORES'
export const LISTAR_RAMAIS = 'LISTAR_RAMAIS'
export const GET_SPECIFIC_OPERADOR = 'GET_SPECIFIC_OPERADOR'
export const GET_ALL_DEPARTAMENTS = 'GET_ALL_DEPARTAMENTS'
export const GET_SPECIFIC_DEPARTAMENT = 'GET_SPECIFIC_DEPARTAMENT'
export const LISTAR_GRUPOS_DE_ROTAS = 'LISTAR_GRUPOS_DE_ROTAS'
